<template>
  <div>
    <span class="white--text" v-if="countdown !== ''">{{ countdown }}</span>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'OtpCountdown',
  data () {
    return {
      targetDate: localStorage.getItem('o_exp_at')
        ? moment(localStorage.getItem('o_exp_at'))
        : moment(),
      countdown: ''
    }
  },
  mounted () {
    this.updateCountdown()
    this.intervalId = setInterval(this.updateCountdown, 1000)
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
  methods: {
    updateCountdown () {
      const now = moment()
      const duration = moment.duration(this.targetDate.diff(now))
      const minutes = Math.floor(duration.asMinutes())
      const seconds = Math.floor(duration.asSeconds()) % 60
      if (duration.asMilliseconds() <= 0) {
        clearInterval(this.intervalId)
        this.countdown = ''
        this.$emit('finish')
      } else {
        this.countdown = `0${minutes} : ${
          String(seconds).length === 2 ? seconds : '0' + seconds
        }`
      }
    }
  }
}
</script>
